const fields = (t) => {
  const translate = (key, fallback) => {
    if (typeof t !== 'function') return fallback

    const translated = t(key)

    return translated === key ? fallback : translated
  }

  return [
    {
      label: translate('deliveryRequest.fields.senderName', 'Nama Pengirim'),
      key: 'parent_company.name',
      isSortable: true,
      isRedirectable: true,
      tdAttr: {
        style: 'left:0;position:sticky;min-width:250px;max-width:250px',
      },
      thAttr: {
        style: 'left:0;position:sticky;min-width:250px;max-width:250px;z-index:1;',
      },
    },
    {
      label: translate('delivery.fields.status', 'Status'),
      key: 'status.name',
      tdAttr: {
        style: 'left:250px;min-width:190px;position:sticky;',
      },
      thAttr: {
        style: 'left:250px;min-width:190px;position:sticky;z-index:1;',
      },
    },
    {
      label: translate('delivery.fields.estimatedDelivered', 'Target Terkirim'),
      key: 'parent_expected_delivered_on',
      isSortable: true,
    },
    {
      label: translate('deliveryRequest.fields.requestDeliveryNumber', 'No. Pengiriman Pengirim'),
      key: 'parent_number',
      isSortable: true,
    },
    {
      label: translate('delivery.fields.customerName', 'Nama Pelanggan'),
      key: 'parent_customer.name',
      isSortable: true,
    },
    {
      label: translate('delivery.fields.originAddress', 'Alamat Asal'),
      key: 'parent_origin_address.name',
      isSortable: true,
    },
    {
      label: translate('delivery.fields.destinationAddress', 'Alamat Tujuan'),
      key: 'parent_destination_address.name',
      isSortable: true,
    },
    {
      label: translate('delivery.fields.deliveryNumber', 'No. Pengiriman'),
      key: 'delivery_order.number',
      isSortable: true,
    },
    {
      label: translate('delivery.fields.totalLoad', 'Total Muatan'),
      key: 'parent_load_count',
      isSortable: true,
    },
    {
      label: translate('delivery.fields.loadWeight', 'Berat Muatan'),
      key: 'parent_load_weight',
      isSortable: true,
    },
    {
      label: translate('delivery.fields.loadVolume', 'Volume Muatan'),
      key: 'parent_load_volume',
      isSortable: true,
    },
  ]
}

export default fields
